<template>
    <div class="section">
        <section class="section_slide-one">
            <div class="container-fluid h-100">
                <div class="InnerText row h-100">
                    <div class="col-lg-8 h-100">
                        <div class="container h-100 p-relative">
                            <div class="innerCenter">
                                <div class="main-content">
                                    <!-- <div class="upperheading">
                                        <h2 class="text-light">REGULATORY AFFAIRS</h2>
                                        <hr>
                                    </div> -->
                                    <div class="main_text-wrapper">
                                        <div class="scrollWrapper">
                                            <scrollbar :ops="scrollSettings">
                                                <div class="scroll_pading innerText text-light">
                                                    <p v-for="bannerText in this.main_banner.header_text" :key="bannerText">{{bannerText}}</p>
                                                </div>
                                            </scrollbar>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>  
                        </div>
                    </div>
                    <div class="col-lg-4 h-100 color-section">
                        <div class="main_content p-relative h-100">
                            <div class="center_content">
                                <h4 class="text-light" v-html="this.main_banner.title"></h4>
                            </div>
                            <div class="See-more" v-on:click="ScrollTop">
                                <div class="mousePointer">
                                    <div class="svgContainer">
                                        <a>  
                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="42.602" viewBox="0 0 30 42.602">
                                            <g id="mouse" transform="translate(-67.726 12)">
                                                <g id="Group_72" data-name="Group 72" transform="translate(67.726 -12)">
                                                <g id="Group_71" data-name="Group 71">
                                                    <path id="Path_52" data-name="Path 52" d="M90.726,0a15.136,15.136,0,0,0-15,15.235V27.367a15,15,0,1,0,30,.047V15.235A15.136,15.136,0,0,0,90.726,0ZM102.9,27.414a12.18,12.18,0,1,1-24.357-.047V15.235a12.181,12.181,0,1,1,24.357,0Z" transform="translate(-75.726)" fill="#fff"/>
                                                </g>
                                                </g>
                                                <g id="Group_74" data-name="Group 74" transform="translate(80.869 5.145)">
                                                <g id="Group_73" data-name="Group 73">
                                                    <path id="Path_53" data-name="Path 53" d="M240.428,140.15a1.544,1.544,0,0,0-1.382,1.666v5.832a1.406,1.406,0,1,0,2.763,0v-5.832A1.544,1.544,0,0,0,240.428,140.15Z" transform="translate(-239.046 -140.15)" fill="#fff"/>
                                                </g>
                                                </g>
                                            </g>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                                <div class="innerSeemor">
                                    <a href="#">
                                        {{this.main_banner.exploreText}}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { gsap } from 'gsap';
export default {
    props:{
        scrollSettings: Object,
        main_banner: Object
    },
    methods:{
         ScrollTop(){
            let FullHeight = window.innerHeight;
            document.body.scrollTop = FullHeight;
            document.documentElement.scrollTop = FullHeight;
            
        },
        customAnimation() {
            let timeLine = gsap.timeline();
            timeLine
                .fromTo(
                document.querySelector(".color-section"),
                { x: "100%" },
                { x: 0, opacity: 1, ease: "power3.out", delay: 0.8, duration: 1 }
                )
                .fromTo(
                ".center_content",
                { y: "-10%", autoAlpha: 0 },
                { y: 0, autoAlpha: 1, duration: 0.7 }
                )
                .fromTo(
                ".See-more",
                { y: "100%" },
                { y: 0, duration: 0.5, ease: "power1.out" },
                "-=.7"
                )
                .fromTo(
                ".innerSeemor",
                { y: 50, opacity: 0 },
                { y: 100, opacity: 1, duration: 0.8 },
                "-=.5"
                )
                .fromTo(
                ".svgContainer",
                { y: -45, opacity: 0 },
                {
                    y: 0,
                    opacity: 1,
                    ease:
                    ("custom",
                    "M0,0 C0.11,0.494 -0.01,0.756 0.116,0.882 0.248,1.014 0.504,1 1,1 "),
                    duration: 0.2,
                },
                "-=.7"
                )
                .fromTo(
                ".upperheading h2",
                { y: "-70%", opacity: 0 },
                { y: 0, opacity: 1, ease: "power1.out", duration: 0.4 },
                "-=1"
                )
                .fromTo(
                ".scroll_pading ",
                { y: "-50%", opacity: 0 },
                { y: 0, opacity: 1, ease: "power3.out", duration: 1 },
                "-=1"
                )
                .fromTo("hr", { width: 0 }, { width: "100%", duration: 1 }, "-=1");
        },
         customAnimation_ar(){
            let timeLine = gsap.timeline();
            timeLine
                .fromTo(
                document.querySelector(".color-section"),
                { x: "-100%" },
                { x: 0, opacity: 1, ease: "power3.out", delay: 0.8, duration: 1 }
                )
                .fromTo(
                ".center_content",
                { y: "-10%", autoAlpha: 0 },
                { y: 0, autoAlpha: 1, duration: 0.7 }
                )
                .fromTo(
                ".See-more",
                { y: "100%" },
                { y: 0, duration: 0.5, ease: "power1.out" },
                "-=.7"
                )
                .fromTo(
                ".innerSeemor",
                { y: 50, opacity: 0 },
                { y: 100, opacity: 1, duration: 0.8 },
                "-=.5"
                )
                .fromTo(
                ".svgContainer",
                { y: -45, opacity: 0 },
                {
                    y: 0,
                    opacity: 1,
                    ease:
                    ("custom",
                    "M0,0 C0.11,0.494 -0.01,0.756 0.116,0.882 0.248,1.014 0.504,1 1,1 "),
                    duration: 0.2,
                },
                "-=.7"
                )
                .fromTo(
                ".upperheading h2",
                { y: "-70%", opacity: 0 },
                { y: 0, opacity: 1, ease: "power1.out", duration: 0.4 },
                "-=1"
                )
                .fromTo(
                ".scroll_pading ",
                { y: "-50%", opacity: 0 },
                { y: 0, opacity: 1, ease: "power3.out", duration: 1 },
                "-=1"
                )
                .fromTo("hr", { width: 0 }, { width: "100%", duration: 1 }, "-=1");
        },
    },
    mounted(){
        // setTimeout(this.customAnimation(), 100);
        this.$i18n.locale=="en" ? setTimeout(this.customAnimation(), 100) : setTimeout(this.customAnimation_ar(), 100);
    }
}
</script>

<style>

</style>